import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CastForEducationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cast_for_education"}/>
}
